import { Component, ElementRef, HostListener, OnInit } from '@angular/core';

@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss'],
    standalone: false
})
export class NavComponent implements OnInit {

  showBookingMenu = false;

  constructor(private elementRef: ElementRef) { }

  ngOnInit(): void {
  }

  toggleBookingMenu(): void {
    this.showBookingMenu = !this.showBookingMenu;
  }

  closeBookingMenu(): void {
    this.showBookingMenu = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.showBookingMenu && !this.elementRef.nativeElement.contains(event.target)) {
      this.showBookingMenu = false;
    }
  }

}
